document.querySelectorAll(".nav").forEach((el) => {
    el.props = {}
    el.querySelectorAll(".nav__main-menu-link").forEach((button, index) => {
        button.addEventListener("click", () => {
            const innerContainer = el.querySelector(".nav--mobile__inner-container")

            if (el.classList.contains("nav--mobile")) {
                const scroller = innerContainer || el.querySelector(".container")
                if (scroller) {
                    console.log(scroller)

                    requestAnimationFrame(() => {
                        scroller.scrollTop = 0
                        scroller.scrollLeft = 0
                        if (typeof scroller.scrollTo === "function") {
                            scroller.scrollTo({ top: 0, left: 0, behavior: "auto" })
                        }
                    })
                }
            }
        })
    })
})